import { render } from "./areaCodeDrop.vue?vue&type=template&id=470468e0&scoped=true&ts=true"
import script from "./areaCodeDrop.vue?vue&type=script&lang=ts"
export * from "./areaCodeDrop.vue?vue&type=script&lang=ts"

import "./areaCodeDrop.vue?vue&type=style&index=0&id=470468e0&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470468e0"]])

export default __exports__